/**
 * Moves a background image in relation to the mouse position.
 * 
 * @export
 * @class ReactiveBG
 */
export class ReactiveBackground {
    private strength: number;
    private background: HTMLElement;

    constructor(container: Element, background: HTMLElement, strength = 0.9) {
        this.strength   = (strength > 1) ? 1 : strength;
        this.strength   = strength * 100
        this.background = background;

        // Set our event listener
        container.addEventListener('mousemove', (evt: Event) => {
            this.setPosition((evt as MouseEvent).clientX, (evt as MouseEvent).clientY);
        });
    }


    /**
     * Sets the position of our background
     * 
     * @param evtX The clientX value of the mousemove event
     * @param evtY The clientY value of the mousemove event
     */
    private setPosition(evtX: number, evtY: number) {
        const offsets = this.getOffset(evtX, evtY)
        const x       = offsets.x / this.strength;
        const y       = offsets.y / this.strength;
        this.background.style.transform = `translate(-${x}px, -${y}px)`;
    }


    /**
     * Returns an object containing our
     * 
     * @param evtX The clientX value of the mousemove event
     * @param evtY The clientY value of the mousemove event
     */
    private getOffset(evtX: number, evtY: number) {
        let el = this.background;
        let x = 0
        let y = 0;

        while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
            x  += el.offsetLeft - el.scrollLeft;
            y  += el.offsetTop - el.scrollTop;
            el  = <HTMLElement>el.offsetParent;
        }

        x = evtX - x;
        y = evtY - y;

        return { x, y };
    }
}
